import { render } from "./ClientLoginForm.vue?vue&type=template&id=d11676cc"
import script from "./ClientLoginForm.vue?vue&type=script&lang=js"
export * from "./ClientLoginForm.vue?vue&type=script&lang=js"

import exportComponent from "/var/srv/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__